import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "completion"]

  updateCompletion(event) {
    const panel = event.target.closest("[data-localized-fields-target='panel']")
    if (!panel) return

    const field = panel.querySelector(`[name$="[${panel.dataset.requiredField}]"]`)
    if (!field || !this.hasCompletionTarget) return

    const complete = field.value.trim().length > 0
    const status = this.completionTarget
    status.dataset.complete = complete.toString()
    status.textContent = complete ? status.dataset.completeLabel : status.dataset.incompleteLabel
    status.classList.toggle("bg-emerald-50", complete)
    status.classList.toggle("text-emerald-700", complete)
    status.classList.toggle("bg-amber-50", !complete)
    status.classList.toggle("text-amber-800", !complete)
  }
}
